import { ORDER_PRIMARY_PHASE_META } from '../../charts/pipeline/lib/orderPrimaryPhaseConfig';
import { ORDER_APPROVAL_STATUS_APPROVED_VALUES } from '../../../../utils/order/orderStatus';

/** 主阶段筛选项中排除：审批态（统计固定查已审批，不单独筛审批中/驳回） */
const CHECKPOINT_PHASE_EXCLUDED = new Set(['pendingApproval', 'approvalRejected']);

export const STATISTICS_CHECKPOINT_PHASE_OPTIONS = ORDER_PRIMARY_PHASE_META.filter(({ phase }) => !CHECKPOINT_PHASE_EXCLUDED.has(phase)).map(
	({ phase, label }) => ({ value: phase, label }),
);

/**
 * 订单状态筛选补丁：统计以流程节点为唯一状态口径；
 * 财务/物流原始状态不再作为筛选入口（仍清空历史/URL 残留）。
 * 审批始终锁定为已审批；关单筛选已下线。
 */
export const applyOrderStatusFilterPatch = (currentFilters = {}, patch = {}) => {
	const next = {
		...currentFilters,
		...patch,
		approvalStatuses: [...ORDER_APPROVAL_STATUS_APPROVED_VALUES],
		isCompleted: '',
		paymentStatuses: [],
		deliveryStatuses: [],
		statusFilterAdditive: false,
	};

	delete next.approvalUiValues;

	return next;
};

/** URL / 历史筛选：剥离财务/物流原始状态与附加模式；审批/关单不可由 URL 覆盖 */
export const normalizeExclusiveOrderStatusFilters = (filters = {}) => ({
	...filters,
	approvalStatuses: [...ORDER_APPROVAL_STATUS_APPROVED_VALUES],
	isCompleted: '',
	paymentStatuses: [],
	deliveryStatuses: [],
	statusFilterAdditive: false,
});

/** 将状态规则结果转为上层 merge 可用的 patch */
export const buildOrderStatusFilterPatch = (currentFilters = {}, userPatch = {}) => {
	const next = applyOrderStatusFilterPatch(currentFilters, userPatch);
	const mergedPatch = { ...userPatch };
	delete mergedPatch.approvalUiValues;

	const affectedKeys = ['approvalStatuses', 'primaryPhases', 'paymentStatuses', 'deliveryStatuses', 'isCompleted', 'statusFilterAdditive'];
	for (const key of affectedKeys) {
		const prevValue = currentFilters[key];
		const nextValue = next[key];
		const changed = Array.isArray(nextValue) || Array.isArray(prevValue)
			? JSON.stringify(nextValue ?? []) !== JSON.stringify(prevValue ?? [])
			: nextValue !== prevValue;
		if (changed) {
			mergedPatch[key] = nextValue;
		}
	}

	return mergedPatch;
};
